import React from 'react';

export type StatProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  delta?: React.ReactNode;
  deltaDirection?: 'up' | 'down';
  className?: string;
  valueClassName?: string;
};

export const Stat: React.FC<StatProps> = ({
  label,
  value,
  delta,
  deltaDirection,
  className = '',
  valueClassName = '',
}) => (
  <div className={`stat ${className}`}>
    <div className="stat-label">{label}</div>
    <div className={`stat-value ${valueClassName}`}>{value}</div>
    {delta && (
      <div className={`stat-delta ${deltaDirection ?? ''}`}>{delta}</div>
    )}
  </div>
);
